import axios from "axios";
import { z } from "zod";
import { environment } from "../../../environment";
import { errorLog } from "../../../logger";
import { AgreementId, } from "../../Types";
import ValidationError from "../../ZodError";
export const documentTypeOptions = [
    "Advisor Registration",
    "Account Application and Agreement",
    "ACH Authorization Agreement",
    "Authorized Personnel Form",
    "Beneficial Owner Information",
    "Credit Extension Statement of Purpose",
    "Entity Certification of Powers",
    "Federal Funds Wire Agreement",
    "Lending Agreement",
    "ManagedConnect Account Agreement",
    "NetX360 New User ID Request",
    "Replicate Account",
    "Roth IRA Agreement",
    "Traditional IRA Agreement",
    "Transfer of Assets Agreement",
    "Trustee Certification",
    "User ID and eDelivery Request",
    "Inherited Traditional IRA Custodial Account Agreement",
];
const postPlanDocumentUrl = (planId) => environment() === "PROD"
    ? `https://middleware.prod.farther.com/account/v1/admin/plans/${planId}/documents`
    : `https://middleware.uat.farther.com/account/v1/admin/plans/${planId}/documents`;
const PostPlanDocumentRes = z.object({
    signatureId: z.string(),
    signatureUrl: z.string(),
    agreementIds: AgreementId.array(),
});
const createBody = (virtualAccountId, clientIds, documentType) => ({
    virtualAccountId,
    clientIds,
    documentType,
});
export default async function postPlanDocument(planId, virtualAccountId, clientIds, documentType, document, config) {
    const formData = new FormData();
    formData.append("document", document);
    formData.append("documentData", JSON.stringify(createBody(virtualAccountId, clientIds, documentType)));
    const { data } = await axios.post(postPlanDocumentUrl(planId), formData, {
        headers: {
            Authorization: `Bearer ${config.jwt}`,
            Advisor: config.advisorId,
            "Content-Type": "multipart/form-data",
        },
    });
    const decoded = PostPlanDocumentRes.safeParse(data);
    if (decoded.success) {
        return decoded.data;
    }
    else {
        const errorMessage = `postPlanDocument Could not parse`;
        errorLog(errorMessage, decoded.error.message);
        throw new ValidationError(errorMessage, decoded.error.issues);
    }
}
//# sourceMappingURL=postPlanDocument.js.map